'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Icons$FormBuilder = require("./components/Icons.bs.js");
var Input$FormBuilder = require("./components/elements/Input.bs.js");
var Utils$FormBuilder = require("./utils/Utils.bs.js");
var Button$FormBuilder = require("./components/elements/Button.bs.js");
var DomAPI$FormBuilder = require("./utils/DomAPI.bs.js");
var Mixins$FormBuilder = require("./styles/Mixins.bs.js");
var Palette$FormBuilder = require("./styles/Palette.bs.js");
var FormContext$FormBuilder = require("./Context/FormContext.bs.js");
var EmptyBuilder$FormBuilder = require("./components/EmptyBuilder.bs.js");
var FormBuilder__Style$FormBuilder = require("./styles/FormBuilder__Style.bs.js");

function makeInput(question) {
  return {
          id: Utils$FormBuilder.randomString(undefined),
          question: "",
          answer: ""
        };
}

function str(prim) {
  return prim;
}

function FormBuilder$DeleteButton(Props) {
  var onClick = Props.onClick;
  return React.createElement("button", {
              className: Curry._1(Css.merge, {
                    hd: Mixins$FormBuilder.no_default_style,
                    tl: {
                      hd: Curry._1(Css.style, {
                            hd: Css.display("block"),
                            tl: {
                              hd: Css.marginLeft("auto"),
                              tl: {
                                hd: Css.cursor("pointer"),
                                tl: {
                                  hd: Css.opacity(0.4),
                                  tl: {
                                    hd: Css.transition(150, undefined, undefined, "opacity"),
                                    tl: {
                                      hd: Css.borderRadius({
                                            NAME: "em",
                                            VAL: 0.2
                                          }),
                                      tl: {
                                        hd: Css.selector("&:hover, &:focus", {
                                              hd: Css.opacity(1),
                                              tl: {
                                                hd: Css.color({
                                                      NAME: "hex",
                                                      VAL: Palette$FormBuilder.danger
                                                    }),
                                                tl: /* [] */0
                                              }
                                            }),
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }),
                      tl: /* [] */0
                    }
                  }),
              onClick: onClick
            }, React.createElement(Icons$FormBuilder.Delete.make, {}));
}

var DeleteButton = {
  make: FormBuilder$DeleteButton
};

function FormBuilder$InputNumber(Props) {
  var number = Props.number;
  return React.createElement("span", {
              className: Mixins$FormBuilder.align_self_start
            }, String(number) + ".");
}

var InputNumber = {
  make: FormBuilder$InputNumber
};

function FormBuilder(Props) {
  var match = React.useContext(FormContext$FormBuilder.context);
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function () {
          if (state.action === /* Add */2) {
            DomAPI$FormBuilder.scrollToBottom("#form");
          }
          
        }), [state.form]);
  return React.createElement("div", {
              className: FormBuilder__Style$FormBuilder.formContainer
            }, React.createElement("form", {
                  className: FormBuilder__Style$FormBuilder.form,
                  id: "form"
                }, List.length(state.form) === 0 ? React.createElement(EmptyBuilder$FormBuilder.make, {}) : null, $$Array.of_list(List.mapi((function (i, item) {
                            if (item.TAG === /* Text */0) {
                              var input = item._0;
                              return React.createElement("div", {
                                          key: input.id,
                                          className: FormBuilder__Style$FormBuilder.inputContainer
                                        }, React.createElement(FormBuilder$InputNumber, {
                                              number: i + 1 | 0
                                            }), React.createElement("div", {
                                              className: FormBuilder__Style$FormBuilder.input
                                            }, React.createElement(Input$FormBuilder.$$Text.make, {
                                                  onChange: (function ($$event) {
                                                      var value = $$event.target.value;
                                                      Curry._1(dispatch, {
                                                            TAG: /* AddText */1,
                                                            _0: input.id,
                                                            _1: value
                                                          });
                                                      
                                                    }),
                                                  value: input.question,
                                                  placeholder: "Type your question here......"
                                                })), React.createElement(FormBuilder$DeleteButton, {
                                              onClick: (function (param) {
                                                  Curry._1(dispatch, {
                                                        TAG: /* DeleteInput */4,
                                                        _0: input.id
                                                      });
                                                  
                                                })
                                            }));
                            }
                            var scaleStart = item._2;
                            var rangeValue = item._1;
                            var input$1 = item._0;
                            return React.createElement("div", {
                                        key: input$1.id,
                                        className: FormBuilder__Style$FormBuilder.inputContainer
                                      }, React.createElement(FormBuilder$InputNumber, {
                                            number: i + 1 | 0
                                          }), React.createElement("div", {
                                            key: input$1.id,
                                            className: Curry._1(Css.merge, {
                                                  hd: FormBuilder__Style$FormBuilder.input,
                                                  tl: {
                                                    hd: Mixins$FormBuilder.flex_col_start_start,
                                                    tl: /* [] */0
                                                  }
                                                })
                                          }, React.createElement(Input$FormBuilder.$$Text.make, {
                                                onChange: (function ($$event) {
                                                    var value = $$event.target.value;
                                                    Curry._1(dispatch, {
                                                          TAG: /* AddText */1,
                                                          _0: input$1.id,
                                                          _1: value
                                                        });
                                                    
                                                  }),
                                                value: input$1.question,
                                                placeholder: "Type your question here..."
                                              }), React.createElement("div", {
                                                className: Curry._1(Css.merge, {
                                                      hd: Mixins$FormBuilder.flex_start_center,
                                                      tl: {
                                                        hd: Curry._1(Css.style, {
                                                              hd: Css.paddingTop({
                                                                    NAME: "rem",
                                                                    VAL: 1
                                                                  }),
                                                              tl: /* [] */0
                                                            }),
                                                        tl: /* [] */0
                                                      }
                                                    })
                                              }, React.createElement(Input$FormBuilder.$$Range.make, {
                                                    onChange: (function ($$event) {
                                                        var value = $$event.target.value;
                                                        Curry._1(dispatch, {
                                                              TAG: /* ChangeRange */2,
                                                              _0: input$1.id,
                                                              _1: value
                                                            });
                                                        
                                                      }),
                                                    value: rangeValue.toString(),
                                                    min: "3",
                                                    max: "11"
                                                  }), React.createElement("div", {
                                                    style: {
                                                      paddingLeft: "0.6em"
                                                    }
                                                  }, String(rangeValue))), React.createElement("div", {
                                                className: Mixins$FormBuilder.flex_start_center
                                              }, React.createElement("input", {
                                                    checked: scaleStart === /* One */1,
                                                    type: "checkbox",
                                                    value: scaleStart === /* One */1 ? "1" : "0",
                                                    onChange: (function ($$event) {
                                                        var value = $$event.target.value;
                                                        Curry._1(dispatch, {
                                                              TAG: /* ChangeScaleStart */3,
                                                              _0: input$1.id,
                                                              _1: value === "1" ? /* Zero */0 : /* One */1
                                                            });
                                                        
                                                      })
                                                  }), React.createElement("span", {
                                                    style: {
                                                      paddingLeft: "0.6em"
                                                    }
                                                  }, " Scale starts at 1"))), React.createElement(FormBuilder$DeleteButton, {
                                            onClick: (function (param) {
                                                return Curry._1(dispatch, {
                                                            TAG: /* DeleteInput */4,
                                                            _0: input$1.id
                                                          });
                                              })
                                          }));
                          }), state.form))), React.createElement("div", {
                  className: FormBuilder__Style$FormBuilder.buttonContainer
                }, React.createElement("p", undefined, "Choose a question type:"), React.createElement("div", {
                      className: Mixins$FormBuilder.flex_start_center
                    }, React.createElement(Button$FormBuilder.make, {
                          onClick: (function (param) {
                              return Curry._1(dispatch, {
                                          TAG: /* AddInput */0,
                                          _0: {
                                            TAG: /* Text */0,
                                            _0: makeInput(undefined)
                                          }
                                        });
                            }),
                          icon: (function (param) {
                              return React.createElement(Icons$FormBuilder.$$Text.make, {});
                            }),
                          text: "Text",
                          type_: /* Secondary */1
                        }), React.createElement(Button$FormBuilder.make, {
                          onClick: (function (param) {
                              return Curry._1(dispatch, {
                                          TAG: /* AddInput */0,
                                          _0: {
                                            TAG: /* Range */1,
                                            _0: makeInput(undefined),
                                            _1: 11,
                                            _2: /* One */1
                                          }
                                        });
                            }),
                          icon: (function (param) {
                              return React.createElement(Icons$FormBuilder.Scale.make, {});
                            }),
                          text: "Scale",
                          type_: /* Secondary */1
                        }))));
}

var make = FormBuilder;

exports.makeInput = makeInput;
exports.str = str;
exports.DeleteButton = DeleteButton;
exports.InputNumber = InputNumber;
exports.make = make;
/* Css Not a pure module */
